<template>
  <v-container 
    fluid
    style="display: flex; justify-content: center; align-items: center; height: 100%; flex-direction: column; position: relative;"
  >
  <v-alert
    color="orange"
    outlined
    dismissible
    type="info"
    style="background-color: rgba(254,250,235,0.95) !important;width: 100%; z-index: 10;"
  >
  <span><strong>This is Demo System</strong></span>
  <br>
  <div v-if="!showKr" @mouseover="showKr = true" style="min-height: 80px;">
    This website is for demonstration purposes.
    At WIKI SECURITY, we deliver optimized security solutions by customizing both the architecture and functionality of this system according to your specific requirements - whether for Cloud, On-Premise, or Hybrid environments.
    When needed, we can also customize our solution to integrate seamlessly with your existing system.
    <!-- <strong>Contact ></strong> wikiadmin@wikisecurity.net, info@wikisecurity.net -->
  </div>

  <div v-if="showKr" @mouseout="showKr = false" style="min-height: 80px;">
    이 웹사이트는 데모용입니다.
    WIKI SECURITY는 당신의 요구사항에 따라 이 시스템을 Cloud 또는 On-Premise 또는 Hybrid로 구성과 기능을 커스터마이징하여 당신에게 최적화된 솔루션으로 제공할수 있습니다. 또한, 경우에 따라서는 당신이 운영중인 다른 시스템과 연동하여 사용될수 있도록 커스터마이징 할수도 있습니다.
  </div>
  <strong>Contact ></strong> wikiadmin@wikisecurity.net, info@wikisecurity.net

  </v-alert>
  <v-card elevation="0" id="introBox" class="pa-2" style="height: 100%; overflow: auto;" >
      <div @click="gotop" style="width: 50px; height: 50px; position: fixed; bottom: 10px; right: 10px; z-index: 1000;">
        <img src="@/assets/arrow-up-bold-circle.svg" class="gotop">
      </div>
      
      <div style="margin-bottom: 10px;">
        <v-card-title class="text-h5 font-weight-medium pb-0">Detect Real Web & API Compromise — Continuously, Not Just Once  </v-card-title>
        <!-- <div class="pa-5" v-if="!rule" @mouseover="rule=true" style="height: 3.0em;"> -->
        <div class="pa-5 pb-0 pt-0" v-if="!rule">
          WIKI-WS is a Web & API Threat Scanner designed not only to identify vulnerabilities, but to   
          continuously detect real-world compromise indicators in live environments. <br><br> 
          Traditional web scanners are typically used for one-time vulnerability assessments.  
          They help identify what could be exploited—but provide little visibility into what is actually   
          happening after the scan is complete.  <br><br>
          WIKI-WS goes beyond this limitation.  
          It enables security teams to continuously monitor and verify the real security state of web and   
          API services, including whether they are already under attack or compromised.  
        </div>
      </div>

      <div style="margin-bottom: 10px;">
        <v-card-title class="text-h5 font-weight-medium pb-0">Why WIKI-WS Exists  </v-card-title>
        <!-- <div class="pa-5" v-if="!rule" @mouseover="rule=true" style="height: 3.0em;"> -->
        <div class="pa-5 pb-0 pt-0" v-if="!rule">
          Modern applications rely heavily on APIs and distributed web architectures, significantly   
          expanding the attack surface.  <br><br>
          However, most existing tools still focus on:  
        </div>
        <div class="d-flex flex-column pa-7 pt-1 pb-1" >
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; One-time vulnerability scanning  
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Theoretical risks based on known categories  
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Pre-exploitation assessment onl  
            </span>
          </div>
        </div>
         <div class="pa-5" v-if="!rule">
          This creates a critical blind spot:<br>  
          “What is happening in my system right now?”<br>
          WIKI-WS was created to answer that question — not once, but continuously.  
        </div>
      </div>


      <div style="margin-bottom: 10px;">
        <v-card-title class="text-h5 font-weight-medium pb-0">What Makes WIKI-WS Different  </v-card-title>
        <!-- <div class="pa-5" v-if="!rule" @mouseover="rule=true" style="height: 3.0em;"> -->
        <div class="pa-5 pb-0 pt-0" v-if="!rule">
          <strong> From One-Time Scanning to Continuous Security Visibility </strong><br>
          Unlike traditional scanners, WIKI-WS is not limited to periodic assessments.<br>  
          It enables ongoing visibility into the security state of live systems.<br>
          <br> 
          <strong>Integrated Vulnerability & Incident Detection</strong><br>
          WIKI-WS combines:  
        </div>
        <div class="d-flex flex-column pa-7 pt-1 pb-1" >
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Vulnerability scanning   
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Webshell detection   
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Malware detection   
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Cryptominer detection 
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Backdoor and malicious activity detection   
            </span>
          </div>
        </div>
        <div class="pa-5 pt-1" v-if="!rule">
          This allows WIKI-WS to function not only as a scanner, but as a lightweight incident detection and management capability.<br>
        </div>

        <div class="pa-5 pt-1" >
          <strong> Detect What Has Already Happened </strong><br>  
          Most tools answer:  <br>  
          | “What could be exploited?”<br>
          WIKI-WS answers:  <br>
          | “What has already been exploited—and what is happening now?”<br>
          <br> 
        </div>

        <div style="margin-bottom: 10px;">
          <v-card-title class="text-h5 font-weight-medium pb-0">What WIKI-WS Detects</v-card-title>
          <div class="pa-5 pb-0 pt-0" v-if="!rule">
            WIKI-WS provides unified detection across:
          </div>
          <div class="d-flex flex-column pa-7 pt-1 pb-1" >
            <div
            v-for="(i, idx) in detectionAcross" :key="idx"
            >
              <span
                  lang="EN-US"
                  style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                  >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                  <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                  >&nbsp; {{ i }}
              </span>
            </div>
          </div>
          <div class="pa-5 pb-0 pt-0" v-if="!rule">
            This enables immediate transition from detection to response.  
          </div>
        </div>
      </div>

      <div id="dev">
        <v-card-title class="text-h5 font-weight-medium pb-0" >How WIKI-WS Compares to Traditional Web Scanners  </v-card-title>
        <div class="pa-5 pt-0" v-if="!overview1"  >
          Traditional scanners focus primarily on identifying potential vulnerabilities. WIKI-WS   
          focuses on detecting real threats and compromise indicators in live web and API   
          environments.    
        </div>
        <div style="width: 100%; margin-bottom: 30px;" class="d-flex justify-center">
          <v-data-table
          :headers="headers"
          :items="items"
          style="width:60%; padding-bottom: 10px"
          :style="$vuetify.breakpoint.width<600?'width:100%;':''"
          hide-default-footer
          disable-sort
          dense
          >
            <template v-slot:body>
              <tbody>
                <tr v-for="(item, index) in items" :key="index" >
                  <!-- 카테고리 셀: rowspan 적용 -->
                  <!-- <template v-if="item.capa == 'Vulnerability Assessment' || item.capa == 'Continuous Monitoring'">
                    <td
                      class="colspanCell"
                      colspan="3"
                      style="font-weight: 600 !important;"
                    >
                      {{ item.capa }}
                    </td>

                  </template> -->
                  <!-- 나머지 셀들 -->
                  <!-- <template v-else> -->
                  <template>
                    <td>{{ item.capa }}</td>
                    <td 
                    style="text-align: center !important;"
                    >
                      <v-icon v-if="item.ws === 'O'" color="success">
                        mdi-check-bold
                      </v-icon>
                      <span v-else>{{ item.ws }}</span>
                    </td>
                    <td 
                    style="text-align: center !important;"
                    >
                      <v-icon v-if="item.aa === 'O'" color="success">
                        mdi-check-bold
                      </v-icon>
                      <v-icon v-else-if="item.aa === 'X'" color="error">
                        mdi-close-thick
                      </v-icon>
                      <span v-else>
                        {{ item.aa }}
                      </span>
                    </td>
                  </template>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </div>
      </div>

      <div style="margin-bottom: 10px;">
        <v-card-title class="text-h5 font-weight-medium pb-0">Where WIKI-WS Fits  </v-card-title>
        <div class="pa-5 pt-1 pb-1" >
          Modern security operations typically rely on multiple layers:
        </div>
        <div class="d-flex flex-column pa-7 pt-1 pb-1">
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Vulnerability scanners identify potential weaknesses   
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp;	Monitoring / SIEM / EDR detect suspicious activities 
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Incident response tools investigate confirmed incidents 
            </span>
          </div>
        </div>
        <div class="pa-5 pt-1 pb-1" >
          However, there is a critical gap between these layers:
        </div>
        <div class="d-flex flex-column pa-7 pt-1 pb-1">
          <div>
             <span
                 lang="EN-US"
                 style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                 >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                 <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                 >&nbsp; Organizations know what vulnerabilities exist 
             </span>
           </div>
          <div>
             <span
                 lang="EN-US"
                 style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                 >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                 <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                 >&nbsp; They respond after incidents are detected
             </span>
           </div>
          <div>
             <span
                 lang="EN-US"
                 style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                 >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                 <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                 >&nbsp; But they cannot easily determine if systems are already compromised 
             </span>
           </div>
        </div>
        <div class="pa-5 pt-1 pb-1" >
          This gap is especially dangerous when:
        </div>
        <div class="d-flex flex-column pa-7 pt-1 pb-1">
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Webshells or backdoors are silently deployed 
            </span>
          </div>
          <div>
              <span
                  lang="EN-US"
                  style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                  >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                  <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                  >&nbsp; Cryptominers or malware operate without triggering alerts 
              </span>
            </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Attacks remain hidden in live environments 
            </span>
          </div>
        </div>
        <div class="pa-5 pt-1 pb-1" >
          WIKI-WS is designed to fill this gap
        </div>
        <div class="d-flex flex-column pa-7 pt-1 pb-1">
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Detects real compromise indicators, not just potential risks 
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Combines vulnerability scanning with webshell, malware, and cryptominer detection
            </span>
          </div>
          <div class="mb-3">
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Provides continuous visibility into the actual security state of web and API services
            </span>
          </div>
        </div>
        <div class="pa-5 pt-0 pb-1" >
          Rather than replacing existing tools, WIKI-WS complements them by bridging the gap between vulnerability assessment and incident response—enabling security teams to answer: “Are we already compromised right now?”
        </div>
      </div>

      <div style="margin-bottom: 30px; text-align: center;">
          <div class="pa-5" v-if="!overview1">
          <i>If your current web scanner only tells you what vulnerabilities exist,<br>
          WIKI-WS goes further — detecting not only web and API vulnerabilities,<br>
          but also whether your web applications are already under attack by real threats <br>
          such as webshells, cryptominers, malware, and more.</i>
          </div>
          
          <!-- <div class="pa-5" v-if="overview1" @mouseout="overview1=false" style=" height: 7.5em;">
            이 강력한 웹 애플리케이션 스캐너는 50개 이상의 잘 알려진 취약점을 빠르게 스캔하여 4가지 심각도(High, Medium, Low, Information)로 분류합니다. 
            탐지된 각 취약점은 OWASP Top10, CWE, WASC 표준에 따라 분석되어 보안을 강화하기 위한 자세한 원인과 수정 단계를 제공합니다.
            이 스캐너는 당신의 웹 애플리케이션 보안을 강화하기 위한 최적의 선택입니다.
          </div> -->
        <!-- <v-card-title class="text-h6" style="padding-bottom: 0px;">1.2 Scan Policies</v-card-title> -->
        
      </div>
    </v-card>
  </v-container>
</template>

<script>
import owaspList from "@/assets/owasp.json"

export default {
    name:'AboutMe',
    data:()=>({
      showKr:false,
      overview1:false,
      overview2:false,
      overview3:false,
      overview4:false,
      rule:false,
      // policies:[
      //   {
      //     type: 'Information Gathering',
      //     content: 
      //       `.env Information Leak<br>
      //       .htaccess Information Leak<br>
      //       Directory Browsing<br>
      //       ELMAH Information Leak<br>
      //       Heartbleed OpenSSL Vulnerability<br>
      //       Hidden File Finder<br>
      //       Remote Code Execution - CVE-2012-1823<br>
      //       Source Code Disclosure - /WEB-INF Folder<br>
      //       Source Code Disclosure - CVE-2012-1823<br>
      //       Spring Actuator Information Leak<br>
      //       Trace.axd Information Leak<br>
      //       User Agent Fuzzer`
      //   },
      //   {
      //     type: 'Injection',
      //     content:
      //       `Buffer Overflow<br>
      //       Cloud Metadata Potentially Exposed<br>
      //       CRLF Injection<br>
      //       Cross Site Scripting<br>
      //       Format String Error<br>
      //       Parameter Tampering<br>
      //       Remote OS Command Injection<br>
      //       Server Side Code Injection<br>
      //       Server Side Include<br>
      //       Server Side Template Injection<br>
      //       Spring4Shell<br>
      //       SQL Injection<br>
      //       XML External Entity Attack<br>
      //       XPath Injection<br>
      //       XSLT Injection`
      //   },
      //   {
      //     type: 'Miscellaneous',
      //     content: 
      //       `External Redirect<br>
      //       Generic Padding Oracle<br>
      //       GET for POST<br>
      //       Log4Shell<br>
      //       Script Active Scan Rules<br>
      //       SOAP Action Spoofing<br>
      //       SOAP XML Injection`
      //   },
      //   {
      //     type: 'Server Security',
      //     content: 
      //       `Path Traversal<br>
      //       Remote File Inclusion`
      //   },
      //   {
      //     type: 'Well-Known',
      //     content: 
      //       `CryptoMiner<br>
      //       Hacking Tool<br>
      //       Webshell<br>
      //       Backdoor<br>
      //       Obfuscation
      //       `
      //   },
      //   {
      //     type: 'Malware',
      //     content: 
      //       `Virus<br>`
      //   }
      // ],
      headers: [
        { text: 'Capability', value: 'capa', align: 'center' },
        { text: 'WIKI-WS', value: 'ws', align: 'center' },
        { text: 'Acunetix/AppScan', value: 'aa', align: 'center' },
      ],
      items: [
        { capa: 'Vulnerability Assessment', ws: '', aa: '' },
        { capa: 'Web Vulnerability Scanning', ws: 'O', aa: 'O' },
        { capa: 'API Vulnerability Scanning', ws: 'O', aa: 'Partial' },
        { capa: 'OWASP Top 10 Coverage', ws: 'O', aa: 'O' },
        { capa: 'Continuous Monitoring', ws: '', aa: '' },
        { capa: 'Webshell Detection', ws: 'O', aa: 'X' },
        { capa: 'Cryptominer Detection', ws: 'O', aa: 'X' },
        { capa: 'Backdoor & Malicious Script Detection', ws: 'O', aa: 'X' },
        { capa: 'Malware Infection Detection', ws: 'O', aa: 'X' },
        { capa: 'Infected Object Identification', ws: 'O', aa: 'X' },
        { capa: 'Threat & Compromise Visibility', ws: 'O', aa: 'X' },
        { capa: 'Focus on Live Environments', ws: 'O', aa: 'Partial' }
      ],
      owasp:[],
      selected:'overview',
      steps:[
        {
          menu: '3.2 Scanner Menu',
          steps:[
            {
              step:`In the 'Scanner' menu, enter the url to scan and the login information for that url.<br>
                    And click 'scan' button to start scan<br>
                    (* Login url, id, pw is only required if it is a page that requires login.)`,
              src:[require('@/assets/enterInfo.png')]
            }, 
            {
              step:'When the scan is complete, the scan results are output below.',
              src:[require('@/assets/scanResult.png')]
            },
            {
              step:'You can view previously scanned results in the history box on the right.',
              src:[require('@/assets/scannerHistory.png')]
            }
          ],
        },{
          menu: '3.3 Scan History Menu',
          steps:[
            {
              step:'In the scan history menu, you can view the history of your scan and the results of your previous scan.',
              src:[require('@/assets/scanHistory.png')]
            },
            {
              step:`Click the view button in the table to view the results of that scan history.`,
              src:[require('@/assets/scanHistoryView.png'), require('@/assets/viewPage.png')]
            },
            {
              step:'Click the download button in the table to download the results of that scan history.',
              src:[require('@/assets/scanHistoryDownload.png'), require('@/assets/downloadPage.png')]
            }
          ],
        }
      ],
      detectionAcross:[
        'OWASP Top 10 web application vulnerabilities',  
        'API vulnerabilities aligned with OWASP API Security Top 10',  
        'Webshells deployed after exploitation',  
        'Cryptominers abusing system resources',
        'Malware and virus infections',  
        'Backdoors and unauthorised scripts',  
        'Traces of hacking tools',  
        'Affected files, scripts, and objects (object-level visility)'  
      ]
    }),
    created(){
      this.owasp=owaspList.owasp
    },
    mounted(){
      console.log(this.items)
      var secondMenu= document.getElementById("rule");
      var thirdMenu= document.getElementById('how');
      var fourthMenu= document.getElementById('dev');

      var secondHeight=secondMenu.getBoundingClientRect().top-150;
      var thirdHeight=thirdMenu.getBoundingClientRect().top-200;
      var fourthHeight=fourthMenu.getBoundingClientRect().top-200;

      window.addEventListener("scroll", function(){
        var scrollPosition = window.scrollY;

        this.selected=scrollPosition>=fourthHeight
        ?'dev':scrollPosition>=thirdHeight
        ?'how':scrollPosition>=secondHeight
        ?'rule':'overview';
        console.log(this.selected);
      }.bind(this));
    },
    methods:{
      isText:function(text){
        if(text.startsWith("@")){
          return true
        }else{
          return false;
        }
      },
      changeText: function(text){
        return text.replace("@","- ")
      },
      // changeLocation:function(location){
      //   this.selected=location;
      //   var location1=document.getElementById(location).offsetTop;
      //   document.getElementById("introBox").scrollTo({top:location1, behavior:'smooth'});
      // },
      gotop:function(){
        document.getElementById("introBox").scrollTo({top:0, behavior:'smooth'});
        this.selected='overview';
      }
    },
    // watch:{
    //   selected:{
    //     handler(newVal){
    //       this.selected=newVal;
    //       console.log(newVal);
    //     },
    //     immediate:true
    //   }
    // }
}
</script>

<style scoped>
::v-deep(.v-alert__wrapper){
  align-items: flex-start !important;
}
::v-deep(.v-alert__wrapper button){
  margin-top: -5px !important;
}
.highlight{
  background-color: #B0BEC5 !important;
  font-weight: 500;
  color: white !important;
}
.gotop{
  filter: invert(63%) sepia(40%) saturate(2909%) hue-rotate(359deg) brightness(100%) contrast(108%);
}
.screenshot{
  width: 450px; 
  height: 250px; 
  margin-top: 5px;
}
.comm_bullet{
    font-size:10.5pt;
    font-family:Wingdings;
    mso-fareast-font-family:굴림;
    
    mso-bidi-font-family:Helvetica;
    color:#333333;
    mso-font-kerning:0pt
}
#introBox::-webkit-scrollbar{
  scrollbar-width: none;
  background: transparent;
}

::v-deep(.v-data-table-header span){
  font-size: 17px !important;
}
::v-deep(.v-data-table){
  border-collapse: collapse !important;
}

::v-deep(.v-data-table tbody tr td){
  font-size: 15px !important;
  border-right: 1px solid #E0E0E0 !important;
}
::v-deep(.v-data-table-header tr th){
  background-color: #cfd8dc !important;
  color: black !important;
  border-right: 1px solid #E0E0E0 !important;
}
::v-deep(.v-data-table tbody tr td:last-child){
  border-right: none !important;
}
::v-deep(.v-data-table-header tr th:last-child){
  border-right: none !important;
}
::v-deep(.v-data-table tbody tr:nth-child(1)){
  background-color: rgb(255, 240, 184) !important;
  font-weight: 600 !important;
}
::v-deep(.v-data-table tbody tr:nth-child(5)){
  background-color: rgb(255, 240, 184) !important;
  font-weight: 600 !important;
}
::v-deep(.v-data-table tbody tr > .colspanCell){
  border: transparent !important;
} 

::v-deep(.v-data-table-header tr th:nth-child(2)){
  border-left: 4px solid red !important;
  border-right: 4px solid red !important;
} 

::v-deep(.v-data-table tbody tr td:nth-child(2)){
  border-left: 4px solid red !important;
  border-right: 4px solid red !important;
} 

::v-deep(.v-data-table tr:first-child th:nth-child(2)){
  border-top: 4px solid red !important;
} 

::v-deep(.v-data-table tr:last-child td:nth-child(2)){
  border-bottom: 4px solid red !important;
} 



</style>